import React, { useCallback, useRef, useState } from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
// import Carousel from "react-slick";
import styles from "./slider.scss";
import { useEffect } from "react";

const Slider = (props) => {
  const { children, isBgImg, gapInCard } = props;

  const sliderRef = useRef({});

  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);
  // const showPrev = useRef(false);
  // const showNext = useRef(true);

  const scrollSlider = (direction = 1) => {
    if (typeof window !== undefined && typeof window !== "undefined") {
      if (!sliderRef.current) return;
      const cardWidth =
        (sliderRef.current.children[0] &&
          sliderRef.current.children[0].clientWidth) ||
        150;
      sliderRef.current.scrollLeft += cardWidth * direction;
    }
  };

  const scrollHandler = (e) => {
    const node = sliderRef.current;
    if (!node) return;

    const canShowPrev = node.scrollLeft != 0;
    if (showPrev != canShowPrev) setShowPrev(canShowPrev);

    const canShowNext = node.scrollLeft != node.scrollWidth - node.offsetWidth;
    if (showNext != canShowNext) setShowNext(canShowNext);
  };

  useEffect(() => {
    scrollHandler();
  }, [sliderRef.current]);

  const arrowIcon = (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.63386 0.250001C1.51575 0.250001 1.42126 0.285068 1.35039 0.355204L0.641731 1.05656C0.547243 1.1267 0.499999 1.22021 0.499999 1.3371C0.499999 1.454 0.547243 1.5592 0.641731 1.65272L7.05512 8L0.641732 14.3473C0.547244 14.4408 0.5 14.546 0.5 14.6629C0.5 14.7798 0.547244 14.8733 0.641732 14.9434L1.35039 15.6448C1.42126 15.7149 1.51575 15.75 1.63386 15.75C1.75197 15.75 1.85827 15.7149 1.95276 15.6448L9.35827 8.28054C9.45276 8.21041 9.5 8.11689 9.5 8C9.5 7.88311 9.45276 7.78959 9.35827 7.71946L1.95275 0.355204C1.85827 0.285068 1.75197 0.250001 1.63386 0.250001Z"
        fill="#2C2C2C"
      />
    </svg>
  );

  return (
    <div className={styles["wrapper"]}>
      <div
        className={`${styles["cards"]} ${isBgImg ? styles["with-image"] : ""}`}
        ref={sliderRef}
        onScroll={scrollHandler}
      >
        {children}
      </div>
      {showPrev && (
        <button
          className={`${styles["prev-btn"]} ${isBgImg ? styles["with-image"] : ""
            }`}
          onClick={() => scrollSlider(-1)}
        >
          {arrowIcon}
        </button>
      )}
      {showNext && (
        <button className={styles["next-btn"]} onClick={() => scrollSlider(1)}>
          {arrowIcon}
        </button>
      )}
    </div>
  );
};

Slider.propTypes = {
  isBgImg: PropTypes.bool,
};

Slider.defaultProps = {
  isBgImg: false,
};

export default Slider;
